import { router } from "@inertiajs/react";
import axios from "axios";

axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            router.post(route("logout"));
            return { data: undefined };
        }
        return Promise.reject(error);
    },
);
